import { ConstraintEntity, EMPTY_CRITERIA_CONS_ENTITY } from "domain/entity/Criteria/ConstraintEntity";
import { CriteriaConstant } from "presentation/constant/Criteria/CriteriaConstant";
import { useCriteriaTracked } from "presentation/store/Criteria/CriteriaProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { IconButton } from "veronica-ui-component/dist/component/core";
import ConstraintItemPanel from "./ConstraintItemPanel";

const ConstraintGroupPanel = () => {
    const [criteriaState, setCriteriaState] = useCriteriaTracked();
    const { constraints } = criteriaState.componentState.currentSelectItem;
    const CRITERIA_CONSTANT = CriteriaConstant.Table;
    const [itemBlur, setItemBlur] = useState<boolean>(false);


    const onAddConstraintItem = () => {
        setCriteriaState({
            ...criteriaState,
            isForceRefresh: !criteriaState.isForceRefresh,
            componentState: {
                ...criteriaState.componentState,
                currentSelectItem: {
                    ...criteriaState.componentState.currentSelectItem,
                    constraints: [...constraints, { ...EMPTY_CRITERIA_CONS_ENTITY }]
                },
                isSliderOpen: true
            }
        });
        // setRefresh(!refresh);
    }

    const onDeleteConstraintItem = useCallback((removeItem: ConstraintEntity) => {
        const newItems = constraints.filter((item) => item.index !== removeItem.index);
        const updatedItems = newItems.map((item, index) => ({
            ...item,
            index: index
        }));

        setCriteriaState({
            ...criteriaState,
            isForceRefresh: !criteriaState.isForceRefresh,
            componentState: {
                ...criteriaState.componentState,
                currentSelectItem: {
                    ...criteriaState.componentState.currentSelectItem,
                    constraints: updatedItems
                }
            }
        });
        // setRefresh(!refresh);
    }, [constraints, criteriaState, setCriteriaState]);

    const onUpdateConstraintItem = useCallback((updateItem: ConstraintEntity) => {
        const newConstraints = criteriaState.componentState.currentSelectItem.constraints?.map((item, index) => {
            if (index === updateItem.index) {
                return updateItem;
            }
            return item;
        });

        setCriteriaState({
            ...criteriaState,
            isForceRefresh: !criteriaState.isForceRefresh,
            componentState: {
                ...criteriaState.componentState,
                currentSelectItem: {
                    ...criteriaState.componentState.currentSelectItem,
                    constraints: newConstraints
                }
            }
        });
        // setRefresh(!refresh);
    }, [criteriaState, setCriteriaState]);

    useEffect(() => {
        const updatedConstraints = constraints?.map((item, index) => ({
            ...item,
            index: index
        }));
        if (updatedConstraints) {
            setCriteriaState({
                ...criteriaState,
                componentState: {
                    ...criteriaState.componentState,
                    currentSelectItem: {
                        ...criteriaState.componentState.currentSelectItem,
                        constraints: updatedConstraints
                    }
                }
            });
        }
    }, [constraints, criteriaState, setCriteriaState]);

    const onScroll = () => {
        setItemBlur(true);
    };

    const resetScoll = () => {
        setItemBlur(false);
    }

    const memoConstraintItemPanel = useMemo(() => {
        return <>
            {constraints && constraints.map((constraintItem, index) => {
                constraintItem = { ...constraintItem, index: index };
                return (
                    <CriteriaItemContainer>
                        <ConstraintItemPanel
                            panelKey={`constraintItemPanel-${index}`}
                            constraintItem={constraintItem}
                            // criteriaState={criteriaState}
                            onDeleteConstraintItem={onDeleteConstraintItem}
                            onUpdateConstraintItem={onUpdateConstraintItem}
                            itemBlur={itemBlur}
                            onResetScoll={resetScoll}
                        />

                        {criteriaState.isForceRefresh && <></>}
                    </CriteriaItemContainer>
                );
            })}
        </>
    }, [constraints, criteriaState.isForceRefresh, itemBlur, onDeleteConstraintItem, onUpdateConstraintItem]);

    return (
        <div className={"flex-row-item"} onScroll={onScroll} style={{ height: '58vh', maxHeight: '58vh', width: '57vw', overflow: 'scroll', paddingTop: '7px' }}>
            <CriteriaItemContainer>
                <span className='parent-label'>{CRITERIA_CONSTANT.CRITERIA}</span>
                <div className='password-eye constraint-def-add'>
                    <IconButton fileName="Icon-add-row" disabled={criteriaState.componentState.isRead} size="medium" onClick={onAddConstraintItem} toolTipText="Add"></IconButton></div>
            </CriteriaItemContainer>
            <>
                {memoConstraintItemPanel}
            </>
        </div>
    );
}

export default memo(ConstraintGroupPanel);